module.exports = __webpack_public_path__ + "img/avatar-01-140x140.7dd33ecb.png";